var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseDomain } from 'core/domain/common';
var UserTie = /** @class */ (function (_super) {
    __extends(UserTie, _super);
    function UserTie(
    /**
     * User identifier
     *
     * @type {string}
     * @memberof UserTie
     */
    userId, 
    /**
     * Circle creation date time
     *
     * @type {Date}
     * @memberof Circle
     */
    creationDate, 
    /**
     * User full name
     *
     * @type {string}
     * @memberof UserTie
     */
    fullName, 
    /**
     * Avatar URL address
     *
     * @type {string}
     * @memberof UserTie
     */
    avatar, 
    /**
     * If following user approved {true} or not {false}
     *
     * @type {Boolean}
     * @memberof UserTie
     */
    approved, 
    /**
     * List of circles identifire which this user belong to
     */
    circleIdList) {
        var _this = _super.call(this) || this;
        _this.userId = userId;
        _this.creationDate = creationDate;
        _this.fullName = fullName;
        _this.avatar = avatar;
        _this.approved = approved;
        _this.circleIdList = circleIdList;
        return _this;
    }
    return UserTie;
}(BaseDomain));
export { UserTie };



//////////////////
// WEBPACK FOOTER
// ./src/core/domain/circles/userTie.ts
// module id = 885
// module chunks = 50